export const MONTH_NAMES = [
  "",
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const CATEGORY_LABELS = {
  "black-history": "Black history",
  "civil-rights": "Civil rights",
  indigenous: "Indigenous history",
  women: "Women's history",
  lgbtq: "LGBTQ+ history",
  labor: "Labor",
  immigrant: "Immigrant history",
  disability: "Disability justice",
  democracy: "Democracy & voting",
  remembrance: "Remembrance",
};

export const TYPE_LABELS = {
  federal_holiday: "Federal Holiday",
  heritage_month: "Heritage Month",
  observance: "Observance",
  anniversary: "Anniversary",
  birthday: "Birthday",
  remembrance: "Remembrance",
};

export const formatCategory = (key) => CATEGORY_LABELS[key] || key;

export const formatMonth = (m) => MONTH_NAMES[m] || "";

export const formatYear = (y) => (y ? String(y) : "—");

export const sortByDate = (a, b) => {
  const am = a.month ?? 13;
  const bm = b.month ?? 13;
  if (am !== bm) return am - bm;
  const ad = a.day ?? 32;
  const bd = b.day ?? 32;
  if (ad !== bd) return ad - bd;
  return a.title.localeCompare(b.title);
};
